export function convertToInt(value: string | [string]) {
	return Array.isArray(value) ? value.map((val) => parseFloat(val)) : parseFloat(value);
}

export function convertDollarsToCents(value: string | [string]) {
	const dollars = convertToInt(value);
	return Array.isArray(dollars) ? dollars.map((val) => val * 100) : dollars * 100;
}
